// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2yaMi","icon":"index_icon_90bZG"};